"use client"

import { Box, Container, Heading, Text, HStack, Button } from "@chakra-ui/react"
import { Link } from "react-router-dom"
import { motion } from "framer-motion"
import { ArrowRightIcon } from "@heroicons/react/24/outline"

const MotionBox = motion(Box)
const MotionButton = motion(Button)

export default function CTASection() {
    return (
        <Box as="section" py={{ base: 16, md: 20 }} className="bg-gradient-primary position-relative" overflow="hidden">
            {/* Background pattern */}
            <Box
                position="absolute"
                top="0"
                left="0"
                right="0"
                bottom="0"
                opacity="0.1"
                backgroundImage="url('https://www.transparenttextures.com/patterns/cubes.png')"
                zIndex="1"
                className="animate-fadeIn"
            />

            <Container maxW="container.xl" position="relative" zIndex="2">
                <MotionBox
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    textAlign="center"
                    className="animate-fadeInUp"
                >
                    <Heading
                        as="h2"
                        fontSize={{ base: "3xl", md: "4xl" }}
                        fontWeight="bold"
                        color="white"
                        mb={6}
                        className="text-shadow"
                    >
                        Ready to Transform Your Hiring Process?
                    </Heading>
                    <Text fontSize={{ base: "lg", md: "xl" }} color="purple.100" maxW="3xl" mx="auto" mb={10}>
                        Join thousands of employers who have streamlined their recruitment and found exceptional talent on our
                        platform.
                    </Text>
                    <HStack spacing={4} justify="center">
                        <Link to={"https://employer.indiahirings.com/signup"}>
                            <MotionButton
                                size="lg"
                                colorScheme="white"
                                bg="white"
                                color="purple.600"
                                px={8}
                                fontWeight="bold"
                                _hover={{
                                    bg: "blue.50",
                                    transform: "translateY(-2px)",
                                    boxShadow: "lg",
                                }}
                                rightIcon={<ArrowRightIcon className="w-5 h-5" />}
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                className="hover-glow"
                            >
                                Get Started Today
                            </MotionButton>
                        </Link>

                        {/* <MotionButton
                            size="lg"
                            variant="outline"
                            colorScheme="whiteAlpha"
                            px={8}
                            fontWeight="bold"
                            _hover={{ bg: "whiteAlpha.200", transform: "translateY(-2px)" }}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            className="glass-effect"
                        >
                            Schedule a Demo
                        </MotionButton> */}
                    </HStack>
                </MotionBox>
            </Container>
        </Box>
    )
}
